import React from 'react';
import DeviceEditor from './DeviceEditor';

function createEditor( system, props ) {
  if ( system == null ) {
    return null;
  }
  props = props || {};
  props.system = system;
  return <DeviceEditor {...props} /> 
}

module.exports = {
  createEditor
}
